// SaturnRings personalized-product guard.
// Prevents direct product-form/quick-add checkout without required name data.
(function () {
    'use strict';

    var dataNode = document.getElementById('sr-personalization-data');
    var personalizationData = { products: [], notePrefix: 'PERSONALIZED ORDER — MANUAL SUPPLIER REVIEW REQUIRED' };
    try {
        if (dataNode) personalizationData = JSON.parse(dataNode.textContent);
    } catch (error) {
        console.error('SaturnRings personalization data could not be read.', error);
    }

    var PERSONALIZED_VARIANTS = {};
    var PERSONALIZED_HANDLES = {};
    (personalizationData.products || []).forEach(function (product) {
        if (!product || !product.handle || !product.builderId) return;
        PERSONALIZED_HANDLES[product.handle] = product.builderId;
        (product.variantIds || []).forEach(function (variantId) {
            PERSONALIZED_VARIANTS[String(variantId)] = product.builderId;
        });
    });
    var NOTE_PREFIX = personalizationData.notePrefix || 'PERSONALIZED ORDER — MANUAL SUPPLIER REVIEW REQUIRED';

    function builderUrl(productId) {
        return (personalizationData.builderUrl || '/pages/builder') + '?product=' + encodeURIComponent(productId || 'arabic-necklace');
    }

    function currentHandle() {
        var match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
        return match ? match[1] : '';
    }

    function isProductForm(form) {
        var formType = form.querySelector('input[name="form_type"]');
        if (formType) return formType.value === 'product';

        try {
            var action = new URL(form.getAttribute('action') || '', window.location.href);
            return action.origin === window.location.origin && /\/cart\/add(?:\.js)?\/?$/.test(action.pathname);
        } catch (error) {
            return false;
        }
    }

    function productIdForElement(element) {
        if (!element) return '';

        var form = element.form || (element.closest && element.closest('form'));
        if (!form && element.querySelector) {
            form = element.querySelector('form');
        }
        if (form) {
            if (!isProductForm(form)) return '';
            var variantInput = form.querySelector('input[name="id"]');
            return variantInput ? PERSONALIZED_VARIANTS[String(variantInput.value)] || '' : '';
        }

        var sticky = element.closest && element.closest('sticky-add-to-cart');
        if (sticky && PERSONALIZED_VARIANTS[String(sticky.getAttribute('data-current-variant-id') || '')]) {
            return PERSONALIZED_VARIANTS[String(sticky.getAttribute('data-current-variant-id'))];
        }

        return '';
    }

    function redirectToBuilder(productId) {
        window.location.assign(builderUrl(productId));
    }

    function interceptPersonalizedAction(event) {
        var target = event.target;
        var actionable = target && target.closest ? target.closest('button, a, form') : null;
        var productId = productIdForElement(actionable || target);
        if (!productId) return;

        var isProductSubmit = event.type === 'submit';
        var isPurchaseControl = actionable && (
            actionable.matches('form') ||
            actionable.matches('button[name="add"], button.add-to-cart-button, button[type="submit"]') ||
            actionable.matches('a[href="#"], a.shopify-payment-button__button') ||
            actionable.closest('product-form-component, quick-add-component, sticky-add-to-cart')
        );

        if (!isProductSubmit && !isPurchaseControl) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        redirectToBuilder(productId);
    }

    function createProductPagePanel(productId) {
        if (!productId || document.querySelector('.sr-personalization-guard-panel, [data-sr-inline-personalizer]')) return;

        var productForm = document.querySelector('main product-form-component, main form[action*="/cart/add"]');
        if (!productForm) return;

        var panel = document.createElement('div');
        panel.className = 'sr-personalization-guard-panel';
        panel.innerHTML =
            '<strong>Personalization required</strong>' +
            '<span>Enter the exact name and review every option in the SaturnRings builder before checkout.</span>' +
            '<a class="button button--primary" href="' + builderUrl(productId) + '">Personalize this piece</a>';
        productForm.insertAdjacentElement('beforebegin', panel);
        productForm.hidden = true;

        document.querySelectorAll('main variant-picker').forEach(function (element) {
            element.hidden = true;
        });

        document.querySelectorAll('sticky-add-to-cart').forEach(function (element) {
            element.hidden = true;
        });
    }

    function relabelPersonalizedQuickAdds() {
        document.querySelectorAll('quick-add-component').forEach(function (component) {
            if (component.getAttribute('data-sr-personalization-guarded') === 'true') return;
            var productId = productIdForElement(component);
            if (!productId) return;
            component.setAttribute('data-sr-personalization-guarded', 'true');
            component.querySelectorAll('button, a.quick-add__button--choose').forEach(function (button) {
                button.setAttribute('aria-label', 'Personalize in builder');
                var text = button.querySelector('.quick-add__button-text span span, .add-to-cart-text__content span span');
                if (text) text.textContent = 'Personalize';
            });
        });
    }

    async function clearStalePersonalizationNote() {
        try {
            var cartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
            if (!cartResponse.ok) return;
            var cart = await cartResponse.json();
            if (cart.item_count !== 0 || String(cart.note || '').indexOf(NOTE_PREFIX) !== 0) return;

            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ note: '' })
            });
        } catch (e) { }
    }

    function applyGuards() {
        var productId = PERSONALIZED_HANDLES[currentHandle()] || '';
        createProductPagePanel(productId);
        relabelPersonalizedQuickAdds();
    }

    document.addEventListener('submit', interceptPersonalizedAction, true);
    document.addEventListener('click', interceptPersonalizedAction, true);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            applyGuards();
            clearStalePersonalizationNote();
        });
    } else {
        applyGuards();
        clearStalePersonalizationNote();
    }

    var guardObserver = new MutationObserver(applyGuards);
    guardObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
